
namespace GeniuzPOS.Member {
    import fld = MbReport01_DtRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MbReport01_DtGrid extends Serenity.EntityGrid<MbReport01_DtRow, any> {
        protected getColumnsKey() { return MbReport01_DtColumns.columnsKey; }
        protected getDialogType() { return MbReport01_DtDialog; }
        protected getIdProperty() { return MbReport01_DtRow.idProperty; }
        protected getInsertPermission() { return MbReport01_DtRow.insertPermission; }
        protected getLocalTextPrefix() { return MbReport01_DtRow.localTextPrefix; }
        protected getService() { return MbReport01_DtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["posid"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "PosId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["posid"];
            //     };
            // }


            return filters;
        }
    }
}